import { render, staticRenderFns } from "./SelectWarranty.vue?vue&type=template&id=fb23d8fa"
import script from "./SelectWarranty.vue?vue&type=script&lang=js"
export * from "./SelectWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports